export enum FeatureNameEnum {
  CHANGE_BE_VALIDATION = 'CHANGE_BE_VALIDATION',
  GLOBAL_SEARCH = 'GLOBAL_SEARCH',
  TALENTS_SEASON = 'TALENTS_SEASON',
  DISCLAIMER = 'DISCLAIMER',
  SCHEDULE = 'SCHEDULE',
  CHATBOT = 'CHATBOT',
  ONBOARDING = 'ONBOARDING',
  DRAFT_SCORE_GRID = 'DRAFT_SCORE_GRID',
  KUDOS = 'KUDOS',
  DASHBOARD = 'DASHBOARD',
}
